import { MapTo } from '@adobe/aem-react-editable-components';
import PersonalInformationForm, { PersonalInformationFormEditConfig } from './PersonalInformationForm';

export default MapTo('cob-corp-acquisition/components/creditonebank/personal-information-form')(PersonalInformationForm, PersonalInformationFormEditConfig);